import { InternalService } from '../../core/services';
import * as T from './types';

export default abstract class BaseBreadcrumbService extends InternalService {
  protected _defaultSettingsKey: string;
  protected _settingsList: T.BreadcrumbSettingsType[] = [];
  protected _breadcrumbs: T.BreadcrumbItemType[] = [];
  protected _initialBreadcrumbs: T.BreadcrumbItemType[] = [];
  protected _listeners: Map<
    T.BreadcrumbListenerCallbackType,
    T.BreadcrumbListenerCallbackType
  > = new Map();
  protected _isEnabled = false;
  protected _started = false;

  constructor() {
    super();
  }

  protected triggerListeners(): void {
    const breadcrumbs = this.getBreadcrumbs();
    this._listeners.forEach((callback) => callback(breadcrumbs));
  }

  public abstract isEnabled(): boolean;

  public abstract listen(
    callback: T.BreadcrumbListenerCallbackType
  ): () => void;

  public abstract useReactListener(React: any): T.BreadcrumbItemType[];

  public abstract getBreadcrumbs(): T.BreadcrumbItemType[];

  public abstract add(breadcrumbItem: T.BreadcrumbItemType): void;

  public abstract remove(breadcrumbKey: string): void;
}
